// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__1b8Vf","header":"ClearentDisclaimer_header__1wsGC","inner":"ClearentDisclaimer_inner__1bJPI"};